"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialScopePermissions = void 0;
var MaterialScopePermissions;
(function (MaterialScopePermissions) {
    MaterialScopePermissions["filtering"] = "filtering";
    MaterialScopePermissions["sharedMaterialsView"] = "sharedMaterialsView";
    MaterialScopePermissions["materialTransferring"] = "materialTransferring";
    /**
     * @deprecated use organization scope instead
     */
    MaterialScopePermissions["groupsInfoView"] = "groupsInfoView";
    MaterialScopePermissions["materialsLimit"] = "materialsLimit";
    MaterialScopePermissions["tagsManaging"] = "tagsManaging";
})(MaterialScopePermissions = exports.MaterialScopePermissions || (exports.MaterialScopePermissions = {}));
